// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__1-aPt"};